var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-bluesky';
                    var viewUrl = 'sprite.svg#view-icon-bluesky';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-bluesky#icon-bluesky';
                            viewUrl = 'sprite.svg?icon-bluesky#view-icon-bluesky';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 720 720',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };